export default {
    strings: {
        pluginNameCamera: 'Camera',
        noCameraTitle: 'Camera Not Available',
        noCameraDescription: 'In order to take pictures or record video, please connect a camera device',
        recordingStoppedMaxSize: 'Recording stopped because the file size is about to exceed the limit',
        submitRecordedFile: 'Submit recorded file',
        discardRecordedFile: 'Discard recorded file',
        // Shown before a picture is taken when the `countdown` option is set.
        smile: 'Smile!',
        // Used as the label for the button that takes a picture.
        // This is not visibly rendered but is picked up by screen readers.
        takePicture: 'Take a picture',
        // Used as the label for the button that starts a video recording.
        // This is not visibly rendered but is picked up by screen readers.
        startRecording: 'Begin video recording',
        // Used as the label for the button that stops a video recording.
        // This is not visibly rendered but is picked up by screen readers.
        stopRecording: 'Stop video recording',
        // Used as the label for the recording length counter. See the showRecordingLength option.
        // This is not visibly rendered but is picked up by screen readers.
        recordingLength: 'Recording length %{recording_length}',
        // Title on the “allow access” screen
        allowAccessTitle: 'Please allow access to your camera',
        // Description on the “allow access” screen
        allowAccessDescription: 'In order to take pictures or record video with your camera, please allow camera access for this site.',
    },
};
